import { useTranslation } from 'react-i18next';

import { Dialog, DialogContent, DialogTitle, IconButton, Stack } from '@mui/material';

import { Item, LoadingStatus, SectionName } from '../../utils/types';
import { CampaignSectionItem } from '../CampaignSectionItem';
import { IconClose } from '../minicomponents/icons';

interface LegacyCampaignPreviewPopupProps {
  open: boolean;
  onClose: () => void;
  items: Item[];
}

export default function LegacyCampaignPreviewPopup({
  open,
  onClose,
  items,
}: LegacyCampaignPreviewPopupProps) {
  const { t } = useTranslation();

  // Filter to show only completed items
  const completedItems = items.filter(
    (item) => item.status === LoadingStatus.COMPLETED
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          maxHeight: '85vh',
          width: '90vw',
        },
      }}
    >
      <Stack direction="row" alignItems="center" sx={{ pr: 2, py: 2 }}>
        <DialogTitle sx={{ flex: 1, py: 1 }}>
          {t('app.legacy.facebook.popup.title')}
        </DialogTitle>
        <IconButton onClick={onClose} aria-label="close">
          <IconClose />
        </IconButton>
      </Stack>

      <DialogContent dividers sx={{ pt: 2 }}>
        <Stack spacing={2}>
          {completedItems.map((item) => (
            <CampaignSectionItem
              key={item.id}
              item={item}
              sectionName={SectionName.SMM}
              tabName={null}
              isReadOnly
            />
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
